import Vue from 'vue'
import Router from 'vue-router'
import Authenticate from '../components/auth/authenticate.component.vue'
import AuthRedirect from '../components/auth/authRedirect.component.vue'
import QueueList from '../components/queues/queueList.component.vue'
import FailedJobs from '../components/failed-jobs/failedJobs.component.vue'
import SupervisorDashboard from '../components/supervisor/dashboard.vue'
import UsersComponent from '../components/users/users.component.vue'
import JobStatsDashboard from '../components/stats/dashboard.vue'
import Middlewares from './middlewares';


Vue.use(Router);

let router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/auth',
            name: 'Auth',
            component: Authenticate,
            meta: {
                middleware: 'redirectIfAuth',
                hideNavigation: true
            }
        },
        {
            path: '/',
            name: 'Queues',
            component: QueueList,
            meta: {
                middleware: 'jwt'
            }
        },
        {
            path: '/failed-jobs',
            name: 'FailedJobs',
            component: FailedJobs,
            meta: {
                middleware: 'jwt'
            }
        },
        {
            path: '/supervisor/dashboard',
            name: 'SupervisorDashboard',
            component: SupervisorDashboard,
            meta: {
                middleware: 'jwt'
            }
        },
        {
            path: '/auth-redirect',
            name: 'AuthRedirect',
            component: AuthRedirect,
            meta: {
                hideNavigation: true
            }
        },
        {
            path: '/users',
            name: 'UsersComponent',
            component: UsersComponent,
            meta: {
                middleware: 'jwt'
            }
        },
        {
            path: '/job-stats/dashboard',
            name: 'JobStatsDashboard',
            component: JobStatsDashboard,
            meta: {
                middleware: 'jwt'
            }
        }
    ]
});

router.beforeEach((to, from, next) => {
    let middleware = to.meta.middleware;
    if(middleware){
        Middlewares[middleware](to, from).then(function(){
            next();
        }, () => {
            next(Middlewares.redirects[middleware]);
        });
    }else{
        next();
    }
});



export default router;


// WEBPACK FOOTER //
// ./src/router/index.js